import { Fragment, h } from 'preact';
import style from "./accountActions.module.css";
import {iconUser, iconUser2} from "../../../../assets/";
import {useAppContext, useUserContext} from "../../../../contexts";
import DropdownContent from "./DropdownContent";
import {useMediaQuery} from "../../../../hooks";
import {route} from "preact-router";

const AccountActions = () => {
    // Destructures the need data from the user context
    const [data, {signOut}] = useUserContext();
    
    const {
        accessibilityFont,
        highContrast
    } = useAppContext();

    const matches = useMediaQuery('(max-width: 767px)');

    return (
        <Fragment>
            <div
                className={style.accountActions}
                data-testid={"account-actions-container"}
                onClick={() => (matches && !data.isSignedIn)  ? route("/entre", false) : {}}
            >
                <div className={"flex flex-col items-end py-3"}>
                    <p
                        className={`hidden md:block uppercase leading-none text-black ${highContrast ? "text-white" : ""}`}
                        style={{fontSize: `${14 + accessibilityFont}px`}}
                        data-testid="account-actions-username"
                    >
                        {!data.isSignedIn ? "Entre / Cadastre-se" : data.firstName}
                    </p>
                    <p
                        className={`
                            block md:hidden uppercase leading-none text-black 
                            ${highContrast ? "text-white" : ""}
                        `}
                        style={{fontSize: `${12 + accessibilityFont}px`}}
                        data-testid={`header-mobile-account-label`}
                    >
                        {!data.isSignedIn ? (
                            "Entre"
                        ) : (
                            data.firstName
                        )}
                    </p>
                    <p
                        className={`uppercase leading-none text-sabin-red-default md:text-sabin-text-2 ${style.accountText} ${highContrast ? "highTitleThird" : ""}`}
                        style={{fontSize: window.innerWidth >= 768 ? `${12 + accessibilityFont}px` : `${10 + accessibilityFont}px`}}
                    >
                        Minha conta
                    </p>
                </div>
                <img
                    src={iconUser}
                    alt={"User icon"}
                    className={`hidden md:block ${style.userIcon}  ${highContrast ? style.accountYellowFilter : ""}`}
                    data-testid="account-actions-img"
                />
                <img
                    src={iconUser2}
                    alt={"User icon"}
                    className={`block md:hidden ${style.userIcon}  ${highContrast ? style.accountYellowFilter : ""}`}
                    data-testid="account-actions-img"
                />
                <div
                    className={`font-museo absolute select-none uppercase w-full top-[56px] md:top-[52px] text-center right-[-66px] md:right-0 shadow rounded px-6 bg-white border border-gray-200 ${highContrast ? "grayBackground" : ""} ${style.dropdownContainer}`}
                    style={{fontSize: `${12 + accessibilityFont}px`}}
                >
                    {(!matches || (matches && data.isSignedIn)) && (
                        <DropdownContent
                            data={data}
                            highContrast={highContrast}
                            signOut={signOut}
                        />
                    )}
                </div>
            </div>
        </Fragment>
    )
}

export default AccountActions;
